// event tracking

export const eventTrackingSingleSignIn = (step) => {
  if (step && [1, 2, 3].includes(Number(step))) {
    window.dataLayer.push({
      event: `single_step${step}_signIn`,
    })
  }
}

export const eventTrackingSingleSignUpStep1 = (step) => {
  if (+step === 1) {
    window.dataLayer.push({
      event: `sign_up_step_1_next_press`,
    })
  }
}

export const eventTrackingSingleSignInStep1 = (step) => {
  if (+step === 1) {
    window.dataLayer.push({
      event: `sign_in_step_1_next_press`,
    })
  }
}

export const eventTrackingSignUpSingle = (step) => {
  if (step && [1, 2, 3].includes(Number(step))) {
    window.dataLayer.push({
      event: `single_step${step}_signUp`,
    })
  }
}